<template>
  <AdblockTopbar />
  <div class="relative px-4 sm:px-6 lg:px-16 max-w-screen-xl lg:mx-auto">
    <HeaderApp />
    <Filters
      class="hidden xl:grid grid-cols-13 grid-flow-col justify-center items-center"
      :default-filters="{ visible: false }"
    />
    <div class="flex">
      <span
        class="w-full flex items-center justify-center rounded-md bg-red-600 text-white py-1 px-20 text-center"
      >
        <Icon name="Exclamation" class="w-5 h-5 mr-2" />
        <p class="text-base font-medium">These advertisements aren't visible</p>
      </span>
    </div>
    <div class="library__list py-4 lg:py-10 items-start">
      <Ad
        v-for="ad in advertisements"
        :key="ad.id"
        :data="ad"
        class="library__item"
      />
    </div>
    <teleport to="body">
      <router-view />
    </teleport>
  </div>
</template>

<script>
import { onMounted, onUnmounted, computed, ref } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import HeaderApp from "@/components/Header";
import Filters from "@/components/Filters";
import AdblockTopbar from "@/components/AdblockTopbar";
import Ad from "@/components/Ad/index";
import Icon from "@/components/UI/Icon";

export default {
  components: { HeaderApp, Ad, Filters, AdblockTopbar, Icon },
  setup() {
    const store = useStore();
    const router = useRouter();

    const content = document;

    const continueInfiniteScroll = ref(true);

    onMounted(async () => {
      if (["super", "admin"].includes(store.state.role)) {
        await store.dispatch("GET_ADVERTISEMENTS", { visible: false });
        content.addEventListener("scroll", onScroll);
      } else {
        router.push("/")
      }
    });

    onUnmounted(() => {
      content.removeEventListener("scroll", onScroll);
    });

    const advertisements = computed(() => store.state.advertisements);

    const onScroll = async (event) => {
      if (
        continueInfiniteScroll.value &&
        store.state.totalAdvertisements > advertisements.value.length
      ) {
        if (
          document.querySelector(".library__list").offsetHeight <
          parseInt(content.documentElement.scrollTop) +
            event.srcElement.documentElement.clientHeight
        ) {
          continueInfiniteScroll.value = false;
          await store.dispatch("GET_ADVERTISEMENTS", { visible: false });
          continueInfiniteScroll.value = true;
        }
      }
    };

    return { advertisements, onScroll, continueInfiniteScroll };
  },
};
</script>

<style scoped>
.library__list {
  @apply grid gap-y-10 gap-x-10;
  justify-content: space-between;
  grid-template-columns: repeat(auto-fit, minmax(19rem, 22rem));
}
.library__item {
  max-width: 24rem;
  min-width: 18rem;
  width: 100%;
}
</style>
